/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';

import InputTrigger from '@ott/input-trigger';
import Overlay from '@ott/overlay';
import PlusMinus from '@ott/plus-minus';
import RadioButtonGroup from '@ott/radio-button-group';
import Button from '@ott/button';
import ChevronDownIcon from '@ott/icon-chevron-down';

import { l10n } from '@ott/l10n';
import { withLayoutContext } from '@ott/layout-context';
import declOfNum from '@ott/utility-decl-of-num';

import s from './ToursNights.scss';
import cls from 'classnames/bind';

import noop from 'lodash/noop';

const nightsDecl = ['ночь', 'ночи', 'ночей'];

const cx = cls.bind(s);

@withLayoutContext
class ToursNights extends PureComponent {
  static propTypes = {
    nightsField: PropTypes.shape({
      input: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
      meta: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    }),
    flexNightsField: PropTypes.shape({
      input: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
      meta: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)).isRequired,
    }),

    isDisabled: PropTypes.bool,

    placeholder: PropTypes.string,
    overlayPlacement: PropTypes.string,

    // уголки скруглять, надо добавить в InputTrigger после
    inputPositionInOrder: PropTypes.string,

    className: PropTypes.string,
    innerClassName: PropTypes.string,
    childrenClassNames: PropTypes.shape({
      container: PropTypes.string,
    }),

    onFocus: PropTypes.func,
    onBlur: PropTypes.func,

    specificLocators: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  };

  static defaultProps = {
    placeholder: 'Длительность',
    overlayPlacement: 'left',
    childrenClassNames: {},
    onFocus: noop,
    onBlur: noop,
    specificLocators: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  componentWillUnmount() {
    clearTimeout(this._closeTO);
    this.unbindOutsideClicks();
  }

  componentDidUpdate() {
    if (this.state.isOpen) {
      this.bindOutsideClicks();
    } else {
      this.unbindOutsideClicks();
    }
  }

  bindOutsideClicks() {
    if (!this._bound) {
      const { isTouchDevice } = this.props;
      const eventName = isTouchDevice ? 'touchend' : 'click';

      document.addEventListener(eventName, this.handleClickOutside);
      this._bound = true;
    }
  }

  unbindOutsideClicks() {
    if (this._bound) {
      const { isTouchDevice } = this.props;
      const eventName = isTouchDevice ? 'touchend' : 'click';

      document.removeEventListener(eventName, this.handleClickOutside);
      this._bound = false;
    }
  }

  // eslint-disable-next-line react/no-find-dom-node
  getContainer = () => findDOMNode(this);

  handleBubble = (e) => {
    if (e) {
      e.stopPropagation();
      if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
      }
    }
  };

  // eslint-disable-next-line consistent-return
  handleClick = (e) => {
    const { isDisabled } = this.props;

    if (isDisabled) {
      return null;
    }

    const { isOpen } = this.state;

    this.handleBubble(e); // todo check

    // eslint-disable-next-line react/no-find-dom-node
    const triggerNode = findDOMNode(this.trigger);
    if (triggerNode.contains(e.target)) {
      if (isOpen && !this._preventCloseByTriggerClick) {
        this.handleCloseAsync(e);
      } else {
        this.handleOpen(e);
      }
    }
  };

  handleOpen = (e) => {
    clearTimeout(this._closeTO);

    ['nightsField', 'flexNightsField'].forEach((entity) => {
      const field = this.props[entity];
      if (field.input) {
        field.input.onFocus(e);
      }
    });

    this.setState({ isOpen: true });

    const { onFocus } = this.props;
    onFocus();
  };

  handleClose = (e) => {
    this.setState({ isOpen: false });

    ['nightsField', 'flexNightsField'].forEach((entity) => {
      const field = this.props[entity];
      if (field.input) {
        field.input.onBlur(e);
      }
    });

    const { onBlur } = this.props;
    onBlur();
  };

  // eslint-disable-next-line consistent-return
  handleFocus = (e) => {
    // кейс: инпут активен > клик по адресной строке > клик по инпуту (focus > click)
    // без этого привента handleClick будет скрывать дропдаун
    this._preventCloseByTriggerClick = true;
    // eslint-disable-next-line no-return-assign
    setTimeout(() => (this._preventCloseByTriggerClick = false), 200);

    const { isDisabled } = this.props;

    if (isDisabled) {
      return null;
    }

    this.handleOpen(e);
  };

  handleBlur = () => {
    this.handleCloseAsync();
  };

  // используется для кейсов, когда клик фокусирует элементу, но при этому должен закрывать компонент
  handleCloseAsync = () => {
    this._closeTO = setTimeout(this.handleClose, 30);
  };

  handleClickOutside = (e) => {
    // eslint-disable-next-line react/no-find-dom-node
    const domNode = findDOMNode(this);

    if (!domNode || !domNode.contains(e.target)) {
      this.handleCloseAsync();
    }
  };

  handleEnter = (e) => {
    if (!this.state.isOpen) {
      this.handleOpen(e);
    }
  };

  handleKeyDown = (e) => {
    switch (e.key) {
      case 'Enter':
      case ' ':
        this.handleEnter(e);
        break;
      case 'Escape':
        this.handleBlur(e);
        break;
      default:
      // do nothing
    }
  };

  renderIcon() {
    const { isOpen } = this.state;
    const { withArrowIcon } = this.props;

    if (!withArrowIcon) {
      return null;
    }

    return <ChevronDownIcon className={cx('arrow', { 'arrow-open': isOpen })} />;
  }

  renderTrigger() {
    const {
      placeholder,
      isDisabled,

      nightsField: { meta: nightsMeta = {} },
      flexNightsField: { meta: flexNightsMeta = {} },
      childrenClassNames,
    } = this.props;

    const value = this.getInputValue();
    const placeholderNode = !value && <span className={cx('dimmed')}>{placeholder}</span>;

    const isInvalid = nightsMeta.submitFailed && (flexNightsMeta.invalid || nightsMeta.invalid);

    return (
      <InputTrigger
        isActive={this.state.isOpen}
        isInvalid={isInvalid}
        errorPlacement="top"
        name="nights-trigger"
        iconNode={this.renderIcon()}
        className={childrenClassNames.input}
        ref={(trigger) => {
          this.trigger = trigger;
        }}
      >
        <div
          className={cx('trigger', {
            'trigger--isDisabled': isDisabled,
          })}
        >
          {placeholderNode}
          {value}
        </div>
      </InputTrigger>
    );
  }

  getInputValue() {
    // TODO поставить чтобы счиатть всех
    const {
      nightsField: { input: nightsInput = {} },
      flexNightsField: { input: flexNightsInput = {} },
    } = this.props;

    return (
      <span>
        {nightsInput.value} {declOfNum(nightsInput.value, nightsDecl)}
        {flexNightsInput.value && <span className={cx('dimmed')}> ±2</span>}
      </span>
    );
  }

  getNightsLabel(value) {
    return `${value} ${declOfNum(value, nightsDecl)}`;
  }

  plusMinusClassNames = {
    quantity: s.plusMinus,
  };

  getContainerNode() {
    const { isOpen } = this.state;

    if (!isOpen) {
      return null;
    }

    const {
      nightsField: { input: nightsInput = {} },
      flexNightsField: { input: flexNightsInput = {} },
      endDateLabel,

      innerClassName,
      overlayPlacement,
      childrenClassNames,
      hasDoneButton,
    } = this.props;

    return (
      <Overlay show={true} container={this.getContainer} placement={overlayPlacement}>
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={cx(
            'container',
            {
              [`container--placement-${overlayPlacement}`]: overlayPlacement,
            },
            childrenClassNames.container
          )}
          tabIndex="-1"
          onMouseDown={this.handleOptionFocus}
          onFocus={this.handleOptionFocus}
          onBlur={this.handleOptionBlur}
        >
          <div className={cx('inner', innerClassName)}>
            <PlusMinus
              min={2}
              max={15}
              value={nightsInput.value}
              label={this.getNightsLabel(nightsInput.value)}
              onChange={nightsInput.onChange}
              childrenClassNames={this.plusMinusClassNames}
            />

            <div className={cx('flexNightsWrapper')}>
              <RadioButtonGroup
                className={cx('flexNights')}
                options={[
                  { name: 'Ровно', value: false },
                  { name: '±2 ночи', value: true },
                ]}
                defaultIndex={flexNightsInput.value ? 1 : 0}
                onChange={flexNightsInput.onChange}
              />
            </div>

            {endDateLabel && <div className={cx('endDateLabel', 'dimmed')}>{endDateLabel}</div>}

            {hasDoneButton && (
              <div className={cx('done-button')}>
                <Button withFullWidth={true} size="medium" onClick={this.handleCloseAsync}>
                  {l10n('travellersControl.done')}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Overlay>
    );
  }

  render() {
    const { className, style, specificLocators } = this.props;

    const handlers = {
      onMouseDown: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
    };

    return (
      <div
        className={cx('ToursNights', className)}
        style={style}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex="0"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...handlers}
        data-locator={cls('ToursNights', specificLocators)}
      >
        {this.renderTrigger()}
        {this.getContainerNode()}
      </div>
    );
  }
}

export default ToursNights;
